import React from 'react';
import PropTypes from 'prop-types';

const ImgTag = ({ src, className, isLazy, altText, dataCy }) => (
  <img
    src={src}
    className={className}
    loading={isLazy ? 'lazy' : 'eager'}
    alt={altText}
    role={altText ? 'img' : 'presentation'}
    data-cy={dataCy}
  />
);

ImgTag.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string.isRequired,
  isLazy: PropTypes.bool,
  altText: PropTypes.string,
  dataCy: PropTypes.string
};

ImgTag.defaultProps = {
  src: null,
  isLazy: false,
  altText: '',
  dataCy: null
};

export default ImgTag;
